import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import i18n from '@/i18n'
import 'normalize.css/normalize.css'
import API from './constants/api'
import loadStateView from '@/components/LoadStateView'
import baseLoadStateview from '@/components/BaseLoadStateview'
import Vue2TouchEvents from 'vue2-touch-events'
import VueMeta from 'vue-meta'

import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack
// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
// If you want to use ECharts extensions, just import the extension package and it will work
// Taking ECharts-GL as an example:
// You only need to install the package with `npm install --save echarts-gl` and import it as follows
// import 'echarts-gl'

Vue.config.productionTip = false
Vue.use(API)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(Vue2TouchEvents)

Vue.use(require('echarts'))
Vue.component('v-chart', ECharts)

let mixin = {
  data () {
    return {
      netState: 0
    }
  },
  updated () {
    if (this.$refs.table) {
      this.$refs.table.style.overflowY = 'scroll'
      this.$refs.table.style.height = window.innerHeight - this.$refs.table.offsetTop + 'px'
    }
  },
  methods: {
    navBar () {
      return this.$root.$children[0].$refs.navBar
    }
  }
}
Vue.mixin(mixin)

Vue.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

Vue.component('loadStateView', loadStateView)
Vue.component('baseLoadStateview', baseLoadStateview)

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
